import { routes } from 'defs';
import { EventCustomWarningCodes, EventWarningCodes } from 'defs/events';
import { getTargetFromFactory, TargetTypes } from 'defs/notifications';
import { TargetsType } from 'types/NotificationTargets';

const targets: TargetsType = {
	[EventWarningCodes.W01]: {
		primary: {
			type: TargetTypes.Route,
			value: { href: routes.anamnesis.selectCoach.href },
		},
		secondary: {
			type: TargetTypes.Close,
		},
	},
	[EventWarningCodes.W02]: {
		primary: {
			type: TargetTypes.Close,
		},
		secondary: {
			callbackId: 'proceed',
			type: TargetTypes.Action,
		},
	},
	[EventCustomWarningCodes.ProfileLoading]: {
		primary: {
			type: TargetTypes.Reload,
		},
	},
	[EventCustomWarningCodes.ProgramFeedLoading]: {
		primary: {
			type: TargetTypes.Reload,
		},
	},
};

export const get = (key: string) => getTargetFromFactory(targets, key);

export default targets;
